<template>
  <b-row>
    <b-col>
      <b-card>
        <div class="mb-1">
          <i class="ml-2 fa fa-handshake fa-lg"></i><span class="h6 ml-2">{{ $t('menu.agreements.index') + ' ' + $t('menu.agreements.listWaiting')}}</span>
        </div>
        <hr class="mt-1 mb-1">
        <div v-if="isLoadingWaitingAgreements">
          <Loader></Loader>
        </div>
        <div v-else-if="!isLoadingWaitingAgreements && getWaitingAgreements.length < 1">
          {{ $t('views.agreements.list.noAgreements') }}
        </div>
        <table class="table table-responsive-md table-sm table-striped table-hover text-center" v-else>
          <thead>
          <tr>
            <th width="15%">{{ $t('views.agreements.list.dateFrom') }}</th>
            <th width="15%">{{ $t('views.agreements.list.agreementNumber') }}</th>
            <th width="30%">{{ $t('views.agreements.list.paymentPlan') }}</th>
            <th width="20%">{{ $t('views.agreements.list.status') }}</th>
            <th width="30%">{{ $t('views.agreements.list.userData') }}</th>
            <th width="10%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in getWaitingAgreements" :key="item['@id']">
            <td>
              {{ item.dateFrom ? $moment(item.dateFrom).format('YYYY-MM-DD') : ' - ' }}
            </td>
            <td>
              {{ item.number || $t('views.agreements.list.noNumber') }}
            </td>
            <td>
<!--              {{ getPaymentsModelTitle(item.idPaymentsModel) }}-->
            </td>
            <td>
              <div>
                {{ $t(getAgreementStatuses[item.status]) }}
              </div>
              <div>
                <b-badge v-if="item.decisionUser == 0"> {{ $t('views.agreements.list.decisionUser.offer') }} </b-badge>
                <b-badge variant="primary" v-else-if="item.status == 1"> {{ $t('views.agreements.list.decisionUser.waiting') }} </b-badge>
                <b-badge variant="warning" v-else-if="item.decisionUser == 2"> {{ $t('views.agreements.list.decisionUser.rejected') }} </b-badge>
                <b-badge variant="success" v-else-if="item.decisionUser == 3 && item.status == 3">
                  {{ $t('views.agreements.list.decisionUser.accepted') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD hh:mm')}}
                </b-badge>
                <b-badge variant="success" v-else-if="item.decisionUser == 5 && item.status == 3">
                  {{ $t('views.agreements.list.decisionUser.signed') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD hh:mm')}}
                </b-badge>
              </div>
            </td>
            <td>
              {{ item.idClient.fullName || item.idClient.fullName }}
            </td>
            <td v-if="(item.status == 1)">
              <button type="button" class="btn btn-link fa fa-eye fa-lg" @click="showAgreementPreviewHTMLModal(item['@id'])" v-b-tooltip.hover :title="$t('buttons.agreementPreview')">
              </button>
            </td>
            <td v-else></td>
          </tr>
          </tbody>
        </table>
        <Pagination :view="waitingAgreementsView" @getPageNumber="getPageWaitingAgreements($event.page, $event.itemsPerPage)"></Pagination>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'

export default {
  name: 'ClientAgreementsWaiting',
  components: {
    Loader,
    Pagination
  },
  computed: {
    ...mapGetters({
      getAgreementStatuses: 'agreements/list/getAgreementStatuses',
      getPaymentsModelOptions: 'agreements/list/getPaymentsModelOptions',
      getAgreementTypes: 'agreements/list/getAgreementTypes',
      getWaitingAgreements: 'clientAgreements/getWaitingAgreements',
      waitingAgreementsView: 'clientAgreements/getWaitingAgreementsView',
      isLoadingWaitingAgreements: 'clientAgreements/getIsLoadingWaitingAgreements'
    })
  },
  created () {
    if (!(this.getWaitingAgreements.length > 0)) {
      this.fetchWaitingAgreements()
    }
    if (!(this.getPaymentsModelOptions.length > 0)) {
      this.fetchPaymentsModelOptions()
    }
  },
  methods: {
    getPageWaitingAgreements (page, itemsPerPage = undefined) {
      let params = {
        '_page': page,
        'itemsPerPage': itemsPerPage
      }
      this.fetchWaitingAgreements(params)
    },
    getPaymentsModelTitle (id) {
      try {
        // eslint-disable-next-line eqeqeq
        return this.getPaymentsModelOptions.find(model => model.id == id).title
      } catch (e) { console.log(e) }
    },
    showAgreementPreviewHTMLModal (id) {
      this.toggleAgreementPreviewHTMLModal()
      this.setAgreementId(id)
      this.fetchSignBySMSFlag(id)
      this.fetchAgreementAsPDF()
    },
    ...mapActions({
      fetchWaitingAgreements: 'clientAgreements/fetchWaitingAgreements',
      fetchPaymentsModelOptions: 'agreements/list/fetchPaymentsModelOptions',
      fetchAgreementAsPDF: 'agreements/previewModal/fetchAgreementAsPDF',
      fetchSignBySMSFlag: 'agreements/acceptModal/fetchSignBySMSFlag'
    }),
    ...mapMutations({
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal',
      setAgreementId: 'agreements/previewModal/setAgreementId'
    })
  }
}
</script>

<style scoped>

</style>
